export const reportRoutes = [
  {
    path: '/relatorios/:type?',
    name: 'Reports',
    meta: {
      requiresAuth: true,
      menu: true,
      navbarActions: true,
      chat: true
    },
    component: () => import(/* webpackChunkName: 'reports-page' */ 'views/ReportsPage')
  }
]
